"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wizard = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _InfoTooltip = require("../InfoTooltip/InfoTooltip");
var _Buttons = require("./Presets/Buttons");
var _Confirmation = require("./Presets/Confirmation");
var _Loading = require("./Presets/Loading");
require("./Wizard.css");
var _excluded = ["children", "className"]; // Style Imports
// Component Imports
// Preset Screens
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Header = _ref => {
  var children = _ref.children,
    header = _ref.header,
    headerInfo = _ref.headerInfo,
    subHeader = _ref.subHeader,
    _ref$sectionDivider = _ref.sectionDivider,
    sectionDivider = _ref$sectionDivider === void 0 ? true : _ref$sectionDivider;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('zui-wizard-header')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "zui-wizard-header-container"
  }, /*#__PURE__*/_react.default.createElement("h1", null, header), headerInfo && /*#__PURE__*/_react.default.createElement(_InfoTooltip.InfoTooltip, {
    content: headerInfo
  })), subHeader && /*#__PURE__*/_react.default.createElement("h2", null, subHeader), children, sectionDivider && /*#__PURE__*/_react.default.createElement("hr", null));
};
var Container = _ref2 => {
  var children = _ref2.children,
    className = _ref2.className,
    headerProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('zui-wizard', className)
  }, headerProps.header && /*#__PURE__*/_react.default.createElement(Header, headerProps), children);
};
var Wizard = exports.Wizard = {
  Container,
  Loading: _Loading.Loading,
  Buttons: _Buttons.Buttons,
  Confirmation: _Confirmation.Confirmation,
  Header
};
//# sourceMappingURL=Wizard.js.map